<div class="grid grid-nogutter w-screen h-screen login-page-container">
  <div class="col-12 lg:col-6 h-screen overflow-y-auto flex flex-column justify-content-between" id="login-pane">
    <div class="logo-container" role="banner">
      <img class="logo" src="assets/images/my-ccs-med-logo.svg" data-cy="ccs-logo" alt="My CCS Med Logo" />
    </div>
    <div role="main">
      <router-outlet></router-outlet>
    </div>
    <div class="text-center message-container mb-3 mt-auto" role="contentinfo">
      <p class="p2 hidden md:block">
        Need assistance? Call
        <a class="no-underline font-semibold" href="tel:{{ CcsConfig.helpPhone }}">{{ CcsConfig.helpPhone }}</a> or
        email
        <a class="no-underline font-semibold" href="mailto:{{ CcsConfig.helpEmail }}">{{ CcsConfig.helpEmail }}</a>
      </p>
    </div>
  </div>

  <div class="hidden lg:block lg:col-6" role="complementary">
    <div class="h-screen">
      <img src="./assets/images/login-image.jpg" class="w-full h-full block login-image" alt="" />
    </div>
  </div>
</div>
